var _circle, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 36,
    stroke: "currentColor",
    strokeWidth: 3,
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 50 L 86 50 A 36 36 0 0 1 68 78 Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round",
    fill: "currentColor",
    fillOpacity: 0.12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 86,
    y2: 50,
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 68,
    y2: 78,
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettore);
export default __webpack_public_path__ + "static/media/settore.35d14a4a16f1d057a0d84904ce3d6d8f.svg";
export { ForwardRef as ReactComponent };